var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#2B2D32",
    fillOpacity: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3028 7.03437C15.9935 5.72187 14.2497 5 12.3966 5C8.57159 5 5.45909 8.1125 5.45909 11.9375C5.45909 13.1594 5.77784 14.3531 6.38409 15.4062L5.39972 19L9.07784 18.0344C10.0903 18.5875 11.231 18.8781 12.3935 18.8781H12.3966C16.2185 18.8781 19.3997 15.7656 19.3997 11.9406C19.3997 10.0875 18.6122 8.34687 17.3028 7.03437ZM12.3966 17.7094C11.3591 17.7094 10.3435 17.4312 9.45909 16.9062L9.24972 16.7812L7.06847 17.3531L7.64972 15.225L7.51222 15.0062C6.93409 14.0875 6.63097 13.0281 6.63097 11.9375C6.63097 8.75937 9.21847 6.17187 12.3997 6.17187C13.9403 6.17187 15.3872 6.77187 16.4747 7.8625C17.5622 8.95312 18.231 10.4 18.2278 11.9406C18.2278 15.1219 15.5747 17.7094 12.3966 17.7094ZM15.5591 13.3906C15.3872 13.3031 14.5341 12.8844 14.3747 12.8281C14.2153 12.7687 14.0997 12.7406 13.9841 12.9156C13.8685 13.0906 13.5372 13.4781 13.4341 13.5969C13.3341 13.7125 13.231 13.7281 13.0591 13.6406C12.0403 13.1312 11.3716 12.7312 10.6997 11.5781C10.5216 11.2719 10.8778 11.2937 11.2091 10.6312C11.2653 10.5156 11.2372 10.4156 11.1935 10.3281C11.1497 10.2406 10.8028 9.3875 10.6591 9.04062C10.5185 8.70312 10.3747 8.75 10.2685 8.74375C10.1685 8.7375 10.0528 8.7375 9.93722 8.7375C9.82159 8.7375 9.63409 8.78125 9.47472 8.95312C9.31534 9.12812 8.86847 9.54687 8.86847 10.4C8.86847 11.2531 9.49034 12.0781 9.57472 12.1937C9.66222 12.3094 10.7966 14.0594 12.5372 14.8125C13.6372 15.2875 14.0685 15.3281 14.6185 15.2469C14.9528 15.1969 15.6435 14.8281 15.7872 14.4219C15.931 14.0156 15.931 13.6687 15.8872 13.5969C15.8466 13.5187 15.731 13.475 15.5591 13.3906Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14.4,
    fill: "white",
    transform: "translate(5.39981 4.80017)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.c670b2b2.svg";
export { ForwardRef as ReactComponent };